import React, {Component} from 'react';
import {APIClient} from "../../../utils/APIClient";
import {URLQueryStringParser} from "../../../utils/URLQueryStringParser";
import {API_URL} from '../../../settings/local_settings';
import {Loading} from "../../Loading";


import {withRouterParams} from "../../../utils/withRouterParams";

class ConnectGA4Account extends Component {
    constructor(props) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        let code = new URLQueryStringParser().getUrlParams('code');
        let credential_label = localStorage.getItem('pending_credential_label');
        localStorage.removeItem('pending_credential_label');
        new APIClient(API_URL + 'get_access_tokens/ga4/').call('POST', {'code': code, 'credential_label': credential_label}).then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
                this.props.history.push('/agency');
            } else if (data.status === 'OK') {
                this.props.history.push('/agency/conections');
                alert('La cuenta de GA4 fue vinculada con éxito!')
            }
        })
    }

    render() {
        return <Loading message="Por favor espere mientras se conecta su cuenta."/>
    }
}

export default withRouterParams(ConnectGA4Account);
